// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__1izW0","content":"LoadingAlert_content__1RLng"};